import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const Container = styled.div`
  font-family: 'Circular-Std';
  margin: 0;
  gap: 16px;
`

export const CloseIcon = styled.div`
  margin-bottom: 30px;
  cursor: pointer;
  color: ${colors.strongGray};
`

export const Title = styled.div`
  margin-bottom: 16px;
  font-size: 32px;
  font-weight: bold;
`

export const Subtitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${colors.strongGray};
  padding-bottom: 16px;
  margin-bottom: -16px; 
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
`
export const DetailsButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  min-height: 45px;
`

export const Error = styled.div`
  color: ${colors.strongRed};
  font-size: 14px;
`

export const ButtonArea = styled.div`
  display: flex;
  margin-top: 8px;
  flex-direction: column;
`
